var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dynamic-form-tabs-card',{attrs:{"tabs":_vm.viewSchema.tabs,"value":_vm.settings},on:{"submit":function (payload) { return _vm.$emit('submit', payload); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }